import React from 'react';
import { Badge } from './ui';

export default function GroupCard({ group, onOpen }) {
  const videosCount = group.playlist?.length ?? 0;
  const mensajesCount = group.mensajes?.length ?? 0;
  const created = group.createdAt ? new Date(group.createdAt) : null;

  return (
    <div className="rounded-2xl bg-gradient-to-b from-slate-800/60 to-slate-900 border border-white/10 overflow-hidden hover:border-indigo-500/40 transition">
      <div className="aspect-video bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-indigo-500/20 via-slate-700/30 to-slate-900" />
      <div className="p-4 grid gap-3">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h4 className="font-semibold leading-tight">{group.nombre}</h4>
            <div className="text-xs text-white/60 mt-1">
              {created ? `Creado: ${created.toLocaleDateString()}` : null}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge>{videosCount} videos</Badge>
          <Badge>{mensajesCount} mensajes</Badge>
        </div>
        <button
          onClick={() => onOpen(group)}
          className="mt-1 inline-flex items-center justify-center rounded-xl bg-indigo-600 hover:bg-indigo-500 px-3 py-2 text-sm font-medium"
        >
          Administrar
        </button>
      </div>
    </div>
  );
}
